import { render } from "./Merchant-services.vue?vue&type=template&id=461634d4&scoped=true"
import script from "./Merchant-services.vue?vue&type=script&lang=js"
export * from "./Merchant-services.vue?vue&type=script&lang=js"

import "./Merchant-services.vue?vue&type=style&index=0&id=461634d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461634d4"]])

export default __exports__